"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var additionalCarDetailsStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    var defaultPriceFormatting = {
        borderBottom: "1px solid " + palette.primaryDisabled.main,
        padding: '5px 0',
        '& span, div': {
            fontFamily: typography.fontFamily2,
        },
    };
    return {
        wrapper: {
            flexWrap: 'nowrap',
        },
        carSpecsWithoutTopBorder: {
            borderBottom: "1px solid " + palette.primaryDisabled.main,
            fontSize: typography.fontMD,
            fontFamily: typography.fontFamily,
            '& > div': {
                padding: '10px 0',
            },
        },
        carSpecs: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            borderBottom: "1px solid " + palette.primaryDisabled.main,
            fontSize: typography.fontMD,
            fontFamily: typography.fontFamily,
            '& > div': {
                padding: '10px 0',
            },
        },
        totalPrice: __assign({}, defaultPriceFormatting),
        totalAmountPayable: __assign(__assign({}, defaultPriceFormatting), { maxHeight: '40px' }),
        firstRegistrationTax: __assign(__assign({}, defaultPriceFormatting), { maxHeight: '40px' }),
        withoutOptions: {
            maxHeight: '40px',
        },
        price: {},
        label: {},
    };
}, { name: 'Summary_AdditionalCarDetails' });
exports.default = additionalCarDetailsStyles;
